export const columns = [
    { name: 'id', label: 'Id', minWidth: 100 ,align:'center' ,format:null},
    { name: 'name', label: 'Descripción', minWidth: 100 ,align:'center' ,format:((r,v,i)=> `${v}`)},
    { name: 'actions', label: 'Opciones', minWidth: 100, align:'center' ,format:null}    
  ];